import {
	DeepPartial, NullStateDataSource, State, StateDataSource
} from "../datasource/state";
import { Settings } from "../../lib/timer";
import { NullStateInitializer } from "../datasource/stateinitializer";

export abstract class StateModel<S extends State> {
	datasource: StateDataSource<S>;

	protected constructor(datasource?: StateDataSource<S>) {
		this.datasource = datasource ?? new NullStateDataSource<S>(new NullStateInitializer<S>());
	}

	abstract getInitialState(config: Settings): Promise<S>
	abstract setState(state: Omit<S, 'timestamp'> & Partial<Pick<S, 'timestamp'>>): Promise<void>
	abstract updateState(state: DeepPartial<S>): Promise<void>
}

export class NullStateModel<S extends State> implements StateModel<S> {
	datasource: StateDataSource<S>;

	getInitialState(config: Settings): Promise<S> {
		throw new Error("Method not implemented.");
	}

	setState(state: Omit<S, 'timestamp'> & Partial<Pick<S, 'timestamp'>>): Promise<void> {
		throw new Error("Method not implemented.");
	}

	updateState(state: DeepPartial<S>): Promise<void> {
		throw new Error("Method not implemented.");
	}
}